export default __webpack_public_path__ + "static/media/screen_dropbox_1.0fbe8b40.png";